import Cookies from 'js-cookie'

function getCookie(CookieName: string) {
  const cookieValue = Cookies.get(CookieName) || ''
  let objectValue = null
  try {
    objectValue = JSON.parse(cookieValue)
  } catch (error) {
    return cookieValue
  }
  return objectValue
}

function setCookie(CookieName: string, CookieValue: any) {
  const strCookieValue = typeof CookieValue == 'object' ? JSON.stringify(CookieValue) : CookieValue
  return Cookies.set(CookieName, strCookieValue)
}

function removeCookie(CookieName: string) {
  return Cookies.remove(CookieName)
}

export {getCookie, setCookie, removeCookie}
